import { GatewayConsumer } from '@/configs';
import { http, defaultConfig, getUniversityUrl, showError } from './http';

export interface GatewayBank {
  id: number;
  className: string;
  displayName: string;
}

export interface TransferInfo {
  messages: string[];
  maxCreditTransferAmount: number;
  minCreditTransferAmount: number;
}
export interface PaymentTransactions {
  content: any[];
  sort: any;
  size: number;
  totalElements: number;
  pageable: any;
  last: boolean;
  totalPages: number;
  number: number;
  first: boolean;
  empty: boolean;
  numberOfElements: number;
}

export interface GatewayInfo {
  active: boolean;
  amounts: number[];
  banks: GatewayBank[];
  canCustomAmountPay: boolean;
}

export interface GatewayPayload {
  id: number;
  active: boolean;
  canCustomAmountPay: boolean;
  className: string;
  displayName: string;
  creationDate: string;
  authzAmountNames: string;
  authzAmountNamesInNewLine: string;
  authzAmounts: number[];
  authzBankNames: string;
  authzBanks: GatewayBank[];
}

export interface CheckoutResult {
  result: string;
  amount: number;
  message: string;
  success: boolean;
  callBackAppUrl: string;
  requestAttributes: {
    requestTransactionUrl: string;
    redirectFormMethod?: string;
    tokenIdentity?: string;
  };
}

export interface ProcessPaymentResponse {
  // if status 302
  url?: string;

  // if status 200
  bankUrl?: string;
  httpMethod?: string;
}

export const fetchConsumers = async () => {
  const baseURL = getUniversityUrl();
  return (await http.get('/rest/modules/epayment/processing/consumers', defaultConfig(baseURL))).data;
};

export const fetchGateways = async (consumer: string = GatewayConsumer.CreditCharge) => {
  const baseURL = getUniversityUrl();
  return (await http.get<{ payload: GatewayPayload }>(`/rest/modules/epayment/processing/gateways?consumer=${consumer}`, defaultConfig(baseURL))).data;
};

export const fetchTransferInfo = async () => {
  const baseURL = getUniversityUrl();
  return (await http.get<{ payload: TransferInfo }>('/rest/credit-transfers', defaultConfig(baseURL))).data;
};

export const openCreditIncreasePage = (token: string) => {
  const baseURL = getUniversityUrl();
  window.open(
    `${baseURL}/j_security_check?loginAsToken=${token}&redirect=/nurture/user/credit/charge/view.rose?callBackAppUrl=https://samad.app/redirect?action=CreditIncrement`,
    '_self'
  );
};

export const transferCredit = async ({ username, amount, nurtureProfileId = null }) => {
  const baseURL = getUniversityUrl();
  return (await http.put<{ payload: TransferInfo }>('/rest/credit-transfers', {
    username,
    creditTransferAmount: amount * 10, // server accepts rials
    nurtureProfileId
  }, defaultConfig(baseURL))).data;
};

export const checkout = async ({
  amount,
  callBackAppUrl,
  consumer,
  gatewayId,
  currentPhase = 0,
}) => {
  const baseURL = getUniversityUrl();
  return (await http.post<{ payload: ProcessPaymentResponse }>
    ('/rest/modules/epayment/processing/v3/payment-gates/process-payment', {
      amount,
      callBackAppUrl,
      consumer,
      gatewayId: Number(gatewayId),
      currentPhase,
    }, defaultConfig(baseURL)));
};

export const toGateway = ({ url, tokenIdentity = undefined }) => {
  if (!tokenIdentity) {
    if (!url) {
      showError('این درگاه پاسخ نمیدهد');
    }
    window.location.href = url;
    return;
  }
};

export const paymentReport = async (page: number, pageSize: number) => {
  const baseURL = getUniversityUrl();
  return (await http.get<{ payload: PaymentTransactions }>(`/rest/payment-transactions/current?page=${page}&size=${pageSize}`, defaultConfig(baseURL))).data;
  };
